module.exports = __webpack_public_path__ + "static/img/Bintro2.0043067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Bintro2.png
// module id = Y2Vu
// module chunks = 1